import React from "react";
import { TbCheck } from "react-icons/tb";
import styles from "./Pricing.module.css";

const PaymentSuccess = () => {
  return (
    <div className={`page-container ${styles.paymentResultPage}`}>
      <div
        className={`${styles.paymentResultIcon} ${styles.paymentResultIconSuccess}`}
      >
        <TbCheck />
      </div>

      <h1 className={`heading ${styles.paymentResultTitle}`}>
        Payment <span className="gradientText">Successful!</span>
      </h1>
      <p className={styles.paymentResultSubtitle}>
        Thank you for choosing iFillip!
      </p>
      <p className={styles.paymentResultText}>
        Your payment has been received successfully, and the receipt has been
        sent to your registered email address.
      </p>
      <p className={styles.paymentResultText}>
        We're now setting up your iFillip account. Your login credentials will
        be sent to your registered email address within 1 hour.
        Please check your email to access your account once the credentials
        arrive.
      </p>

      <p className={styles.paymentResultContact}>
        Need help getting started? Contact our dedicated support team at{" "}
        <a
          href="mailto:support@ifillip.com"
          className={styles.paymentResultLink}
        >
          support@ifillip.com
        </a>
      </p>
    </div>
  );
};

export default PaymentSuccess;
